import UtilService from '../../common/services/util.service';

/* @ngInject */
export default class StorageService {
    private msisdnKey = "JTIybXNpc2RuJTIy";
    private expire = 840000;

    constructor() { }

    public setMsisdn(msisdn) {
        UtilService.setSessionStorageWithExpire(this.msisdnKey, this.encrypt(msisdn), this.expire);
    }

    public getMsisdn(): string {
        return this.decode(UtilService.getSessionStorageWithExpire(this.msisdnKey));
    }

    public removeMsisdn() {
        sessionStorage.removeItem(this.msisdnKey);
    }

    
    private decode(data) {
        if (!data) {
            return;
        }

        if (angular.isString(data)) {
            const decrypted = atob(data);
            const decoded = decodeURIComponent(decrypted);
            return angular.fromJson(decoded);
        }
    }

    private encrypt(data) {
        if (!data) {
            return;
        }
        const json = angular.toJson(data);
        const encoded = encodeURIComponent(json);
        return btoa(encoded);
    }
}



// WEBPACK FOOTER //
// src/app/no-auth/services/storage.service.ts